import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { AnchorMixin } from '@zillow/constellation';

import { logDeprecateMessage } from '../../util/logging/logging';
import linkMixIn from '../../themes/components/Link';

const Link = (props) => {
  logDeprecateMessage(`The 'Link' component from zrs-comet will be removed in the next MAJOR release, use 'Anchor' or 'TextButton' from constellation instead.
    http://constellation.pages.zgtools.net/constellation-site/constellation-api.html#anchor
    http://constellation.pages.zgtools.net/constellation-site/constellation-api.html#textbutton`);
  const { to, className, escape, reactRouterLink, icon, iconSize, ...rest } = props;

  let linkProps = { ...rest, icon, className };
  let LinkElement = 'a';
  if (!to) {
    // eslint-disable-next-line no-self-assign
    linkProps = linkProps;
  } else if (to.indexOf('http') > -1 || to[0] === '#' || props.target || escape) {
    linkProps.href = to;
  } else if (reactRouterLink) {
    LinkElement = reactRouterLink;
    linkProps.to = to;
  }

  const StyledLinkElement = styled(LinkElement)`
    ${AnchorMixin}
    ${linkMixIn}
  `;

  return (
    <StyledLinkElement data-test={props['data-test']} {...linkProps}>
      {icon &&
        React.cloneElement(icon(), {
          size: iconSize,
          className: 'Link-icon-item',
        })}
      {props.children}
    </StyledLinkElement>
  );
};

Link.propTypes = {
  /** the Link component from react-router or react-router-dom, depending on react-router version */
  reactRouterLink: PropTypes.func,
  /** where is it going...to? */
  to: PropTypes.string,
  /** true value will use the 'to' value in the 'href' attr */
  escape: PropTypes.bool,
  /** icon component from the icon library. will be placed before the link */
  icon: PropTypes.func,
  /** 'xs', 'sm', 'md', 'lg', or number in pixels */
  iconSize: PropTypes.string,
  /** styles and stuff if you don't like our styles */
  className: PropTypes.string,
  /** used for testing */
  'data-test': PropTypes.string,
  /** anchor target (Ex. '_blank') */
  target: PropTypes.string,
  /** children */
  children: PropTypes.node,
};

Link.defaultProps = {
  escape: false,
};

export default Link;
